export * from './asset.pipe';
export * from './header.component';
export * from './footer.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/index.ts